<div class="component-content">
  <mat-icon svgIcon="logo"></mat-icon>
  <span class="separator"></span>
  <h1>{{ title }}</h1>

  <div class="navigation-panel">
    <nav *ngIf="(userName$ | async) !== '' && (userRole$ | async) && (userRole$ | async) !== unassignedRole">
      <a mat-button *ngIf="accessService.canSeeTasks()" routerLink="/tasks" routerLinkActive="active" i18n>Tasks</a>
      <a mat-button *ngIf="accessService.canSeeCustomers()" routerLink="/customers" routerLinkActive="active" i18n>Customers</a>
      <a mat-button *ngIf="accessService.canSeeAdminPage()" routerLink="/admin" routerLinkActive="active" i18n>Admin</a>
      <a mat-button *ngIf="accessService.canCanSeeSystemLogs()" routerLink="/system_logs" routerLinkActive="active" i18n>System Log</a>
    </nav>

    <div *ngIf="(userName$ | async) !== ''" class="user">
      <mat-icon svgIcon="user"></mat-icon>
      <span>{{ userName$ | async}}</span>
      <button mat-icon-button aria-label="Logout" (click)="logout()">
        <mat-icon svgIcon="logout"></mat-icon>
      </button>
    </div>
  </div>
</div>